import React, { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import NavigationItem from '../../../components/stateful/NavigationItem/NavigationItem';
import styles from './NavigationV2.scss';
import useCurrentPage from '../../../hooks/useCurrentPage';

const propTypes = {
  inverseBackground: PropTypes.bool,
  navigation: PropTypes.array,
};

const defaultProps = {
  inverseBackground: undefined,
  navigation: [],
};

const NavigationV2 = ({ navigation, primaryButton, secondaryButton, inverseBackground }) => {
  const [expandedGroup, setExpandedGroup] = useState();
  const {
    primaryColorBorderClass,
    primaryColorClass,
    primaryColorBackgroundClass,
    buttonStyleClass,
  } = useCurrentPage();

  const onClick = (id) => {
    setExpandedGroup(id === expandedGroup ? null : id);
  };

  return (
    <div className={styles.navigation}>
      {navigation.map(item => (
        <NavigationItem
          topLevel
          inverseBackground={inverseBackground}
          key={item.id}
          item={item}
          onClick={onClick}
          expandedGroup={expandedGroup}
        />
      ))}
      {secondaryButton && (
        <a
          className={
            cx(
              styles.button,
              styles.secondaryButton,
              buttonStyleClass,
              {
                [primaryColorBorderClass]: !inverseBackground,
                [primaryColorClass]: !inverseBackground,
                [styles.inverseBackground]: inverseBackground,
                [primaryColorBackgroundClass]: inverseBackground,
              },
            )
          }
          href={secondaryButton.link?.href || secondaryButton.page?.path}
          target={secondaryButton.link?.target || '_self'}
        >
          {secondaryButton.text || secondaryButton.page?.title}
        </a>
      )}
      {primaryButton && (
        <a
          className={
            cx(
              styles.button,
              styles.primaryButton,
              buttonStyleClass,
              {
                [primaryColorBackgroundClass]: !inverseBackground,
                [primaryColorBorderClass]: !inverseBackground,
                [styles.inverseBackground]: inverseBackground,
                [primaryColorClass]: inverseBackground,
              },
            )
          }
          href={primaryButton.link?.href || primaryButton.page?.path}
          target={primaryButton.link?.target || '_self'}
        >
          {primaryButton.text || primaryButton.page?.title}
        </a>
      )}
    </div>
  );
};

NavigationV2.propTypes = propTypes;
NavigationV2.defaultProps = defaultProps;

NavigationV2.fragments = NavigationItem.fragments;

export default NavigationV2;
